// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__2nSeW","title":"BackImages_title__KH5Np","images":"BackImages_images__2dlGc"};